import { ApiProduct } from '@vend/types'
import filter from 'lodash/filter'
import { store } from '../../factories/database/database'
import { useSyncManager } from '../../ng-compat/hooks'
import { isProductActive } from '../../factories/search/product-index-util'

export const useProductCodeSearch = () => {
  const syncManager = useSyncManager()
  const productsIndexDB = store('products').index('byProductCode')

  return async (query: string): Promise<ApiProduct | undefined> => {
    // Wait until products have been sinced.
    await new Promise<void>((resolve, reject) =>
      syncManager
        .whenCompleteEntityDataAvailable('products')
        .then(() => resolve())
        .catch(err => reject(err))
    )

    const rawProducts = await productsIndexDB.getAll(query)
    // Filter inactive products.
    const products = filter(rawProducts, isProductActive)

    if (products.length > 0) {
      // Product codes are unique.
      return products[0]
    }
  }
}
